import React from "react";
import { Row, Col, Form, Input, Button, notification } from "antd";

import _service from "@netuno/service-client";
import Cluar from "../../../common/Cluar";

import "./index.less";

export default ({ title }) => {
  const onFinish = (values) => {
    _service({
      url: "newsletter",
      method: "POST",
      data: values,
      success: (res) => {
        if (res.json.result) {
          notification.success({
            message: Cluar.plainDictionary("success-newsletter"),
            description: Cluar.plainDictionary(
              "success-description-newsletter"
            ),
          });
        } else {
          if (res.json.error === "email-exists") {
            notification.error({
              message: Cluar.plainDictionary("error-newsletter"),
              description: Cluar.plainDictionary("email-exists-newsletter"),
            });
          }
        }
      },
    });
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  return (
    <section className="lead-form">
      <h2 style={{ display: "block" }}>{title}</h2>
      <Form
        name="newsletter"
        wrapperCol={{ span: 8 }}
        initialValues={{ remember: true }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete="off"
      >
        <Row gutter={32}>
          <Col xs={24} sm={24} md={12} lg={8} xl={8}>
            <Form.Item
              // label={Cluar.plainDictionary("name-newsletter")}
              name="name"
              style={{ width: "100%" }}
              rules={[
                {
                  required: true,
                  message: Cluar.plainDictionary("required-field"),
                },
              ]}
            >
              <Input placeholder={Cluar.plainDictionary("name-newsletter")} />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={12} lg={8} xl={8}>
            <Form.Item
              // label="E-mail"
              name="email"
              rules={[
                {
                  required: true,
                  message: Cluar.plainDictionary("required-field"),
                  type: "email",
                },
              ]}
            >
              <Input placeholder="E-mail" />
            </Form.Item>
          </Col>
        </Row>
        <Form.Item className="submit-btn">
          <Button type="primary" htmlType="submit">
            {Cluar.plainDictionary("submit-newsletter")}
          </Button>
        </Form.Item>
      </Form>
    </section>
  );
};
